import { render } from "./VerifyPhone.vue?vue&type=template&id=eef9597c&scoped=true"
import script from "./VerifyPhone.vue?vue&type=script&lang=js"
export * from "./VerifyPhone.vue?vue&type=script&lang=js"

import "./VerifyPhone.vue?vue&type=style&index=0&id=eef9597c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eef9597c"]])

export default __exports__